import React, {useEffect} from 'react';
import { isIPad13, isTablet } from "react-device-detect";
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import Select from 'components/atoms/Select';
import { useOrgTreesOptionsAll } from 'hooks/useOrgTreesOptions';
import SelectForm from 'components/molecules/SelectForm';

const OrganizationFilter: React.FC<{
  orgCode: string;
  setOrgCode: (orgCode: string) => void;
  id?: string;
  defaultValue?: any
}> = ({ orgCode, setOrgCode, id= '0', defaultValue }) => {
  const orgTreesOptions = useOrgTreesOptionsAll(undefined, undefined, true);

  useEffect(() => {
    if(orgCode !== null){
      sessionStorage.setItem(`${id}/sessionData${window.location.pathname}.selectedOrgCodeStaffMaster`, orgCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgCode])

  useEffect(() => {
    let session = sessionStorage.getItem(`${id}/sessionData${window.location.pathname}.selectedOrgCodeStaffMaster`);
    if(session !== null){
      setOrgCode(session);
    }else{
      setOrgCode(defaultValue || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <FlexBox customStyle={css({padding: '8px', paddingLeft: 0})}>
      <FlexBoxItem basis="100px">
        <BodyText>部署・組織</BodyText>
      </FlexBoxItem>
      <FlexBoxItem 
        width={isIPad13 || isTablet ? '650px' : "580px"} 
        customStyle={css(isIPad13 || isTablet ? {marginRight: '-105px', marginLeft: '10px'} : {})}
      >
        <SelectForm
          name="orgState"
          value={String(orgCode)}
          setValue={(arg: string) => { setOrgCode(arg); }}
          options={orgTreesOptions}
        />
      </FlexBoxItem>
    </FlexBox>
  );
};

export default OrganizationFilter;
